module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Sachdev-Singh_Poster-0a779c999e05dc9a4f214fd4ab5e5e77.webp";